import { label as yearLabel } from './years';
import { label as makeLabel } from './makes';
import { label as modelLabel } from './models';
import { label as trimLabel } from './trims';
import getVIN from './vin';
import getAccessories from './accessories';
import value from './value';

export async function label({ vin, yearId, makeId, modelId, trimId }) {
  if (vin) {
    const ymmtId = await getVIN(vin);
    if (!yearId && !makeId && !modelId && !trimId) {
      yearId = ymmtId.yearId;
      makeId = ymmtId.makeId;
      modelId = ymmtId.modelId;
      trimId = ymmtId.trimId;
    }
  }

  let year;
  if (yearId) {
    year = await yearLabel({ yearId });
  }

  let make;
  if (makeId) {
    make = await makeLabel({ yearId, makeId });
  }

  let model;
  if (modelId) {
    model = await modelLabel({ yearId, makeId, modelId });
  }

  let trim;
  if (trimId) {
    trim = await trimLabel({ yearId, makeId, modelId, trimId });
  }

  return {
    year,
    make,
    model,
    trim,
  };
}

export const conditionIndexMap = {
  poorTradeInValue: 0,
  fairTradeInValue: 1,
  goodTradeInValue: 2,
}

export async function vehicle({
  yearId,
  makeId,
  modelId,
  trimId,
  vin,
  miles,
  condition,
  singleOwner,
  accountId,
  accessoryIds = []
}) {
  const labels = await label({ vin, yearId, makeId, modelId, trimId });
  let accessories = []
  if (accessoryIds.length > 0 && trimId) {
    accessories = await getAccessories(trimId);
    accessories = accessories.filter(({ id }) => accessoryIds.includes(id));
  }
  let tradeInRanges;
  if (trimId && miles && accountId) {
    const values = await value({ trimId, miles, accountId });
    const accessoriesValue = accessories.reduce((sum, { tradeInValue }) => sum + tradeInValue, 0);
    tradeInRanges = [
      values.poorTradeInValue,
      values.fairTradeInValue,
      values.goodTradeInValue
    ].map(value => value + accessoriesValue);
  }
  return {
    yearId,
    makeId,
    modelId,
    trimId,
    vin,
    accessories,
    tradeInRanges,
    miles,
    singleOwner,
    condition: conditionIndexMap[condition],
    ...labels
  };
}
